import {
  MODAL_BG_HEIGHT,
  MODAL_MOBILE_BG_HEIGHT,
  MODAL_THANK_YOU_BG_HEIGHT,
  PRIVATE_PARTY_THANK_YOU,
} from 'site-modules/shared/constants/private-party/private-party';
import { getQuery } from 'client/utils/location';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import { NON_RANDOMIZABLE_OPTIONS } from 'site-modules/shared/constants/private-party/deactivation-survey-modal';

export const checkIsDisabled = items => !Object.values(items).some(item => item);

export function getBgHeight(step, isMobile) {
  if (step === PRIVATE_PARTY_THANK_YOU) {
    return MODAL_THANK_YOU_BG_HEIGHT;
  }
  return isMobile ? MODAL_MOBILE_BG_HEIGHT : MODAL_BG_HEIGHT;
}

export function getCreateListingUrl(vin, modsId, receivedOffer, isTED7487Enabled) {
  const queryString = objectToQueryString({
    vin,
    modsId,
    receivedOffer,
    ...(isTED7487Enabled ? { skipToPrice: true } : {}),
  });
  return `/sell-car/private/create-listing/${queryString ? `?${queryString}` : ''}`;
}

export function getCreateListingSetListPriceUrl(vin, styleId, modsId) {
  const queryString = objectToQueryString({
    modsId: modsId || undefined,
    styleId: styleId || undefined,
    vin: vin || undefined,
  });
  return `/sell-car/private/create-listing/set-list-price/${queryString ? `?${queryString}` : ''}`;
}

export const isE2ETest = location => getQuery(location)?.e2e === 'true';

export function getShuffledOptions(options) {
  if (!Array.isArray(options)) return options;

  const fixed = options.filter(({ option }) => NON_RANDOMIZABLE_OPTIONS.includes(option));
  const randomizable = options.filter(({ option }) => !NON_RANDOMIZABLE_OPTIONS.includes(option));

  for (let i = 0; i < randomizable.length; i += 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [randomizable[i], randomizable[j]] = [randomizable[j], randomizable[i]];
  }

  return [...randomizable, ...fixed];
}
